(() => {
  const root = window.Shopify?.routes?.root || '/';
  const bonusKey = '🎁 Complimentary Black Friday Gift';
  const configKey = 'Screen protector configuration';
  let pending;
  let queue = Promise.resolve();

  if (!customElements.get('duo-cart-promotion')) {
    customElements.define('duo-cart-promotion', class extends HTMLElement {
      connectedCallback() {
        this.labels = JSON.parse(this.querySelector('[data-bf-promo-labels]').textContent);
      }
      update(cart) {
        this.dataset.count = cart.item_count;
        this.querySelector('[data-bf-cart-progress]').textContent = this.labels.states[Math.min(3, cart.item_count)];
        this.querySelectorAll('[data-bf-milestone]').forEach(node => node.classList.toggle('is-unlocked', cart.item_count >= Number(node.dataset.bfMilestone)));
        this.querySelector('[data-bf-gift-model-wrap]').hidden = cart.item_count < 3 || cart.items.some(item => item.product_type === 'Phone Cases');
      }
    });
  }

  function showProgress(cart) {
    document.querySelectorAll('duo-cart-promotion').forEach(node => node.update(cart));
    document.querySelectorAll('[data-duo-cart-count]').forEach(node => { node.textContent = cart.item_count; });
    document.querySelectorAll('[data-duo-cart-link]').forEach(node => node.setAttribute('aria-label', `${node.dataset.bagLabel}, ${cart.item_count}`));
  }

  function refreshCartSections(cart) {
    if (!cart.sections || !document.querySelector('cart-items-component')) return;
    const event = new Event('shopify:cart:lines-update', {bubbles:true});
    event.bfcmGiftSync = true;
    event.promise = Promise.resolve({
      cart: {id:cart.token, totalQuantity:cart.item_count, cost:{totalAmount:{amount:String(cart.total_price / 100),currencyCode:cart.currency}}, lines:[], discountCodes:[]},
      detail: {sections:cart.sections, items:cart.items, itemCount:cart.item_count, source:'bfcm-gift-sync', didError:false}
    });
    document.dispatchEvent(event);
  }

  async function syncGift() {
    const modelInput = [...document.querySelectorAll('[data-bf-gift-model]')].find(input => !input.closest('[data-bf-gift-model-wrap]').hidden);
    const enteredModel = modelInput?.value.trim().slice(0,100);
    let response = await fetch(root + 'cart.js', {credentials:'same-origin', headers:{Accept:'application/json'}});
    if (!response.ok) throw new Error('Unable to read your bag. Please try again.');
    let cart = await response.json();
    let changed = false;
    for (let attempt = 0; attempt < 30; attempt++) {
      const cases = cart.items.filter(item => item.product_type === 'Phone Cases');
      const candidates = cases.length ? cases : cart.items;
      const owner = cart.item_count >= 3 ? candidates.find(item => item.properties?._bfcm_bonus === '2026') || candidates[0] : null;
      let change;
      for (const item of cart.items) {
        const properties = {...item.properties};
        if (item.key === owner?.key) {
          properties[bonusKey] = '1x Matching Tempered Glass Screen Protector (Auto-matched to your phone model)';
          properties[configKey] = cases.length ? item.variant_title || item.product_title : enteredModel || properties[configKey] || 'Phone model to be confirmed';
          properties._bfcm_bonus = '2026';
          delete properties._bfcm_removed;
        } else if (properties._bfcm_bonus === '2026') {
          delete properties[bonusKey];
          delete properties[configKey];
          delete properties._bfcm_bonus;
        }
        if (JSON.stringify(properties) !== JSON.stringify(item.properties || {})) {
          change = {id:item.key, quantity:item.quantity, properties:Object.keys(properties).length ? properties : {_bfcm_removed:'2026'}};
          break;
        }
      }
      if (!change) {
        showProgress(cart);
        if (changed) refreshCartSections(cart);
        return cart;
      }
      const sections = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(node => node.dataset.sectionId))].filter(Boolean).slice(0,5);
      if (sections.length) {
        change.sections = sections;
        change.sections_url = location.pathname;
      }
      response = await fetch(root + 'cart/change.js', {method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'}, credentials:'same-origin', body:JSON.stringify(change)});
      const result = await response.json();
      if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : 'Unable to confirm your complimentary gift. Please try again.');
      cart = result;
      changed = true;
    }
    throw new Error('Unable to confirm your complimentary gift. Please try again.');
  }

  window.duoBfcmSyncGift = () => pending || (pending = syncGift().finally(() => { pending = null; }));
  function scheduleSync() {
    queue = queue.catch(() => {}).then(async () => {
      if (pending) await pending.catch(() => {});
      return window.duoBfcmSyncGift();
    });
    queue.catch(() => {});
    return queue;
  }

  if (location.pathname.replace(/\/$/,'') === (root+'cart').replace(/\/$/,'')) scheduleSync();
  document.addEventListener('bfcm:cart-added', event => {
    if (event.detail?.cart) showProgress(event.detail.cart);
    scheduleSync();
  });
  document.addEventListener('shopify:cart:lines-update', event => {
    if (event.bfcmGiftSync) return;
    Promise.resolve(event.promise).then(() => scheduleSync()).catch(() => {});
  });
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-bf-gift-model]')) return;
    document.querySelectorAll('[data-bf-gift-model]').forEach(input => { input.value = event.target.value; });
    scheduleSync();
  });

  async function checkout(event, button) {
    if (!button || event.defaultPrevented) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (button.getAttribute('aria-busy') === 'true') return;
    button.setAttribute('aria-busy','true');
    try {
      await queue.catch(() => {});
      await window.duoBfcmSyncGift();
      location.assign(root+'checkout');
    } catch (error) {
      let status = document.querySelector('[data-bf-cart-error]');
      if (!status) {
        status = document.createElement('p');
        status.dataset.bfCartError = '';
        status.setAttribute('role','alert');
        button.insertAdjacentElement('afterend',status);
      }
      status.textContent = error.message;
    } finally {
      button.removeAttribute('aria-busy');
    }
  }
  document.addEventListener('click', event => checkout(event,event.target.closest('[name="checkout"],a[href$="/checkout"],a[href*="/checkout?"]')),true);
  document.addEventListener('submit', event => {
    if (event.submitter?.name === 'checkout') checkout(event,event.submitter);
  },true);
})();
